/* The class names are anchors as well as styles, so each keeps its name:
   - `clickable` is how the e2e suite finds a feed card (`CSS.card` in e2e/src/selectors.ts);
   - `amount` is how it reads the number of a card's price (`CSS.feedAmount`, SF-F4);
   - the root is `listingCard`, not `card`: `[class*="_card_"]` is the purchase-type selector's anchor. */

.listingCard {
  display: flex;
  flex-direction: column;
  /* An anchor brings these along; the card is not a run of text. */
  color: inherit;
  text-decoration: none;
}

/* The ring is the only thing that tells a keyboard user which car they are on — drawn just
   outside the card, in the text colour, on the page's dark background. */
.clickable:focus-visible {
  outline: var(--gac-control-focus-ring) solid var(--gac-text-primary);
  outline-offset: 2px;
}

/* The number and its currency code inside the price slot. It takes the slot's face and size. */
.amount {
  white-space: nowrap;
}
